import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form, actions } from 'react-redux-form';
import { Row, Col } from 'react-bootstrap';
import Translation from "../../../../common/translation/translation.component"
import { CONFIRMATION_VALUE, TRANSLATIONS as translation } from '../../../../../utils/constant.utils';
import {
    ORFButton
    , ORFSearchSuggestions as SearchSuggestions
    , OR_RRF_TextArea as TextArea
} from '../../../../common/forms/order-request-form.component';
import { wirelessPortOutActions } from "./../../../../../store/external/request-reducer/order-request-reducer/wireless-request/wireless-portout.reducer";
import { createRequestActions } from "./../../../../../store/external/request-reducer/create-request.reducer";
import { requestLogActions } from "./../../../../../store/external/request-reducer/request-log.reducer";
import DATEPICKER_OR from '../../../../common/custom-form/custom-date-picker.component';
import { NotificationModal } from '../../../../common/modal/notification-modal.component';
import { ConfirmationNotificationModal } from '../../../../common/modal/confirmation-modal.component';
import { withRouter } from 'react-router-dom';
import { Loading } from '../../../../common/loading/index';
import { CIRCUIT_STATUS, SUBMIT_REQUEST_TITLE } from '../../../../../constants/external-constants';
import { convertUtcToLocalDate } from '../../../../../utils/helpers.utils';

class MobilePortOutForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showConModal: false,
            isSaving: false,
            show: false,
            error: false,
            title:""
        }
    }

    componentWillUnmount() {
        this.props.resetWirelessPortOutForm();
        this.props.resetRequestData();
    }

    async componentDidMount() { 
        const { isUpdateRequest, takeActionCircuitCode, takeActionCircuitId } = this.props.createRequest;
        const { requestDetail, fetchSubscriptionByRequestDetail, onLoadUpdatePortOut, setLoadForm, fetchSubscriptionByValue, onSubscriptionSelect } = this.props;

        if (takeActionCircuitId != null || takeActionCircuitId !== undefined || takeActionCircuitCode) {
            var circuitCodePropName = 'CircuitCode';
            var subscriptionList = await fetchSubscriptionByValue(takeActionCircuitCode, circuitCodePropName);

            onSubscriptionSelect(takeActionCircuitCode, circuitCodePropName, subscriptionList, null, takeActionCircuitId);
        }
        else {
            onSubscriptionSelect('');
        }

        if (isUpdateRequest) {
            const currentCircuitCode = requestDetail.requestData.Circuit.CircuitCode;
            var circuitCodePropName = 'CircuitCode';
            setLoadForm(true);
            var subscriptionList = await fetchSubscriptionByRequestDetail(currentCircuitCode, circuitCodePropName);
            onLoadUpdatePortOut(subscriptionList, circuitCodePropName);
            setLoadForm(false);
        }
    }

    haveError = (value) => {
        this.setState({
            error: value
        })
    }

    submitRequest = () => {       
        this.setState({showConModal:true})
    }

    handleConfirmationModal = async (buttonType) => {
        if (buttonType === CONFIRMATION_VALUE.Ok) {
            const { submitRequest, fetchRequestLogItems } = this.props;
            this.setState({
                isSaving: true,
            });
            var success = await submitRequest();
            let resultMessage = success.Message;
            if (success.Success) {
                fetchRequestLogItems(0);
                this.setState({
                    title: "Success"
                });

                const { isUpdateRequest } = this.props.createRequest;
                resultMessage = isUpdateRequest ? this.toLocaleLanguage("order_has_been_updated") : this.toLocaleLanguage("order_has_been_submitted");
                this.props.hideRequestModal();
            }else {
                this.setState({
                    title: "Error"
                });
                resultMessage = success.Message ? success.Message : this.toLocaleLanguage("order_save_error_message");
            }
               
            this.setState( prev => ({                   
                showConModal: !prev.showConModal,
                show: true,
                isSaving: false,
                message: resultMessage,
            }))
                    
        }else{
            this.setState({
                showConModal: false
            });
        }
    }

    handleCloseNotif = () => {
        this.setState({ show: false });  
        
        if(this.state.title!=="Error")
        {
            this.props.history.goBack();
        } 
    }

    onClickCancel = () => {
        const { modalClose } = this.props;

        if (modalClose) {
            modalClose();
        }
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    isSameParam = () => {  
        const { circuitCode, businessJustification, additionalInformation, terminateDate } = this.props.wirelessPortOutFormA;
        const { requestData } = this.props.requestDetail;
        let isPortOutDt = (requestData.Order.OrderDisconnectDate ? new Date(convertUtcToLocalDate(requestData.Order.OrderDisconnectDate)) : '').toDateString() === (!terminateDate == false ? terminateDate.toDateString() : '');
        let additionalInfo = requestData.BusinessJustification.AdditionalInformation !== null && requestData.BusinessJustification.AdditionalInformation !== '' ?  requestData.BusinessJustification.AdditionalInformation : '';
  
        return (requestData.Circuit.CircuitCode === circuitCode
            && requestData.BusinessJustification.BusinessJustification === businessJustification
            && additionalInfo === additionalInformation
            && isPortOutDt)
    }
    validateData = () => {
        const { wirelessPortOutFormA } = this.props;
        const { formSubmitted } = this.props.wirelessPortOutRequest;
        const { requestOnBehalfData, isRequestOnBehalf, isUpdateRequest } = this.props.createRequest;
      
        if (!wirelessPortOutFormA.circuitId || !wirelessPortOutFormA.terminateDate || !wirelessPortOutFormA.businessJustification || formSubmitted) {
            return true;
        }

        if (isRequestOnBehalf && !(requestOnBehalfData && requestOnBehalfData.EmployeeId > 0)) {
            return true;
        }

        if (isRequestOnBehalf) {
            if (requestOnBehalfData && requestOnBehalfData.EmployeeId > 0 && wirelessPortOutFormA.circuitCode !== '') {
                if (isUpdateRequest) {
                   return this.isSameParam();
                }
            }
        } else {
            if (isUpdateRequest) {
                return this.isSameParam();
            }
        }
      
        return false;
    }

    render() {
        const { subscriptionList, takeActionCircuitCode, isUpdateRequest } = this.props.createRequest;
        const { wirelessPortOutFormA, onSubscriptionSelect, fetchSubscriptionByValue, requestDetail } = this.props;
        const { formSubmitted, subscription, isFormLoading, isResetLoading } = this.props.wirelessPortOutRequest;
        var circuitStatusName = isUpdateRequest && subscriptionList.length ? subscriptionList[0].CircuitStatus : subscription.CircuitStatus != null && subscription.CircuitStatus != "" ? subscription.CircuitStatus : "";

        const initialRequired = wirelessPortOutFormA.circuitId == 0
            || wirelessPortOutFormA.terminateDate == 0
            || wirelessPortOutFormA.businessJustification == ''
            || formSubmitted

        if (isUpdateRequest) { 
            var oldDate = new Date(convertUtcToLocalDate(requestDetail.requestData.Order.OrderDisconnectDate)).toDateString();
            var newDate = (!wirelessPortOutFormA.terminateDate == false ? wirelessPortOutFormA.terminateDate.toDateString() : '');
            var isTerminateDt = !(oldDate === newDate ? true : false);

            var updateRequired = isUpdateRequest && !(requestDetail.requestData.Circuit.CircuitCode != wirelessPortOutFormA.circuitCode
                || isTerminateDt
                || requestDetail.requestData.BusinessJustification.BusinessJustification != wirelessPortOutFormA.businessJustification
                || requestDetail.requestData.BusinessJustification.AdditionalInformation != wirelessPortOutFormA.additionalInformation);
        }

        return isFormLoading ?
            (<div>
                <Loading />
            </div>) : (
            <div>
                <NotificationModal
                    show={this.state.show}
                    title={this.state.title}
                    message={this.state.message}
                    handleModal={this.handleCloseNotif}
                    customClass={'comment-notification-modal notification-footer modal-text-bold'}
                />
                <ConfirmationNotificationModal 
                    show={this.state.showConModal} 
                    message={isUpdateRequest ? this.toLocaleLanguage("update_order_request_confirmation") : this.toLocaleLanguage("create_order_request_confirmation")} 
                    title={isUpdateRequest ? SUBMIT_REQUEST_TITLE.updateRequest : this.toLocaleLanguage("submit_form_request_title")}
                    handleModal={this.handleConfirmationModal}
                    customClass={'comment-notification-modal modal-text-bold'}
                    disabled={this.state.isSaving}
                />
                <Form method="post" role="form"
                    model="wirelessPortOutFormA"
                    onSubmit={this.submitRequest}
                >

                    <Row className='mh-70'>
                        <Col className='required' xs={12} md={12} lg={12}>
                            {
                                !isResetLoading && <SearchSuggestions
                                    value={wirelessPortOutFormA.circuitCode}
                                    label={`${this.toLocaleLanguage('mobile_phone_number')}`}
                                    propDisplay={'CircuitCode'}
                                    options={subscriptionList.length > 0 ? subscriptionList : ''}
                                    onChangeAction={onSubscriptionSelect}
                                    searchAction={fetchSubscriptionByValue}
                                    defaultValue={takeActionCircuitCode}
                                    maxLength={100}
                                    placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                    errorMessage={this.toLocaleLanguage('error_mobile_number_not_exist')}
                                    haveError={this.haveError}
                                />
                            }
                        </Col>
                        {wirelessPortOutFormA.circuitCode != '' &&
                                <div className= "pb-1-pl-30">
                                <span className={circuitStatusName === CIRCUIT_STATUS.inService.name ? "status-inservice" : "status-suspended"}>{circuitStatusName} </span> <span>| </span>
                                    {subscription?.VendorName != null ? subscription.VendorName : ""} <span>| </span>
                                    {!subscription?.PlanName ? <Translation translationKey="no_plan_available" /> : subscription.PlanName} <span>| </span>
                                    {subscription?.DeviceName != null ? subscription.DeviceName : <Translation translationKey="no_device_available" />}
                            </div>
                        }
                    </Row>
                    <div className='mt-2 mb-2'>
                        <span className='text-field-title'><Translation translationKey="port_out_request_details" /></span>
                    </div>
                    <div className='column-width-date-picker'>
                        <div className="date-picker-group">                           
                            <DATEPICKER_OR 
                                label={`${this.toLocaleLanguage('port_out_date')}`}
                                subLabel={`${this.toLocaleLanguage('parenthesis_effectivity_date')}` }
                                placeholder={this.toLocaleLanguage('select_placeholder')}
                                startDate={wirelessPortOutFormA.terminateDate}
                                selectedDate={(date) => this.props.FormChange("wirelessPortOutFormA.terminateDate", date)}
                                requiredField={true}                                
                                minDate={new Date()}
                            />
                        </div>
                    </div>
                    <Row>
                        <Col className='required' xs={12} md={12} lg={12}>
                            <TextArea 
                                label={`${this.toLocaleLanguage('port_out_justification')}`}
                                fieldProp='.businessJustification'
                                value={wirelessPortOutFormA.businessJustification}
                                maxLength={500}
                                placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <TextArea 
                                label={this.toLocaleLanguage('additional_information')}
                                fieldProp='.additionalInformation'
                                value={wirelessPortOutFormA.additionalInformation}
                                maxLength={1000}
                                placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                            />
                        </Col>
                    </Row>
                    <div className="request-button-continer mt-0">
                        <div className="bottom-left">
                            <ORFButton
                                label={this.toLocaleLanguage('modal_close_cancel_button')}
                                variant={"light"}
                                action={this.onClickCancel}
                                type="button"
                            />
                        </div>
                        <div className="bottom-right">
                            <div>
                                <ORFButton
                                    label={this.toLocaleLanguage('submit_request_button')}
                                    variant={"primary"}
                                    type="submit"
                                    disabled= { this.validateData() }
                                />
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        );
    }
};

export default withRouter(connect(
    state => {
        const { createRequest, wirelessPortOutRequest, translation, requestDetail } = state;
        const { wirelessPortOutFormA } = state.form;
        return {
            wirelessPortOutFormA
            , createRequest
            , wirelessPortOutRequest
            , ...translation
            , requestDetail
        };
    }
    , dispatch => ({
        ...bindActionCreators(
            Object.assign({}, wirelessPortOutActions
                , createRequestActions
                , requestLogActions),
            dispatch
        ),
        FormChange: (model, value) => {
            dispatch(actions.change(model, value))
        }
    })
)(MobilePortOutForm));